import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

const LeaseCharge = styled.div`
  padding: 1rem;
  border-bottom: 1px dashed #eaeaea;
`;

const Row = styled.div`
  display: flex;
`;

const Title = styled.div`
  font-family: 'Circular-Bold';
  font-size: 18px;
  flex: 1;
`;
const Amount = styled.div`
  font-family: 'Circular-Bold';
  font-size: 18px;
`;
const YardiLeaseCharge = ({ leaseCharge }) => {
  const { amount, charge_code_description, start_date, end_date } = leaseCharge;

  return (
    <LeaseCharge>
      <Row>
        <Title>{charge_code_description}</Title>
        <Amount>{amount}</Amount>
      </Row>
      <Row>
        {getTranslatedString('landlordPortal.leaseDetailsForm.effective')} {start_date}
        {end_date && ` ${getTranslatedString('landlordPortal.leaseDetailsForm.to')} ${end_date}`}
      </Row>
    </LeaseCharge>
  );
};

export default YardiLeaseCharge;
